<div class="main-content pt-4 mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon">
              <i class="material-icons">receipt</i>
            </div>
            <h4 class="card-title">{{ id ? "Update" : "New" }} registry</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <!-- Información Básica -->
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="urlPath">Url</label>
                    <input
                      type="text"
                      class="form-control"
                      id="urlPath"
                      formControlName="urlPath"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('urlPath')"
                    >
                      url is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="type">Type</label>
                    <input
                      type="text"
                      class="form-control"
                      id="type"
                      formControlName="type"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('type')"
                    >
                      type is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="city">City</label>
                    <input
                      type="text"
                      class="form-control"
                      id="city"
                      formControlName="city"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('city')"
                    >
                      city is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="service"
                      >Service</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="service"
                      formControlName="service"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('service')"
                    >
                      service is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="industry"
                      >Industry</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="industry"
                      formControlName="industry"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('industry')"
                    >
                      industry is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="keyword"
                      >Keyword</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="keyword"
                      formControlName="keyword"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('keyword')"
                    >
                      keyword is required
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <div
                    class="form-group d-flex justify-content-center align-items-center gap-4"
                  >
                    <div class="custom-control custom-switch mt-4 checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="status"
                        formControlName="status"
                      />
                      <label class="custom-control-label" for="status"
                        >Published</label
                      >
                    </div>
                  </div>
                </div>
              </div> -->

              <div class="row text-center">
                <div class="col-md-12">
                  <button
                    type="submit"
                    class="btn btn-dark pull-right btn-create"
                    [disabled]="form.invalid"
                  >
                    {{ id ? "Update" : "Create" }}
                  </button>
                </div>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
      <!-- Historial de Versiones -->
      <div class="col-md-4" *ngIf="id">
        <div class="card h-100">
          <div class="card-header">
            <h4 class="card-title">Version History</h4>
          </div>
          <div
            class="card-body p-0"
            style="max-height: 500px; overflow-y: auto"
          >
            <div class="list-group list-group-flush">
              <div *ngFor="let v of versions" class="list-group-item">
                <div
                  class="d-flex w-100 justify-content-between align-items-center"
                >
                  <h6 class="mb-1">
                    <span class="badge badge-info mr-2"
                      >v{{ v.versionNumber }}</span
                    >
                    <span
                      *ngIf="v._id === registry?.currentVersionId"
                      class="badge badge-success mr-1"
                      >CURRENT</span
                    >
                    <span
                      *ngIf="v._id === registry?.publishedVersionId"
                      class="badge badge-warning mr-1"
                      >LIVE</span
                    >
                    <small class="text-muted">{{ v.source | uppercase }}</small>
                  </h6>
                  <small class="text-muted">{{
                    v.createdAt | date : "short"
                  }}</small>
                </div>
                <p class="mb-1 small">
                  <span
                    *ngFor="let label of v.labels"
                    class="badge badge-dark mr-1"
                    >{{ label }}</span
                  >
                </p>
                <div
                  class="d-flex justify-content-between align-items-center mt-2"
                >
                  <small class="text-muted"
                    >By: {{ v.createdBy?.name || "System" }}</small
                  >
                  <button
                    type="button"
                    (click)="rollback(v._id)"
                    [disabled]="v._id === registry?.currentVersionId"
                    class="btn btn-link btn-sm text-primary p-0"
                  >
                    <i class="fas fa-undo"></i> Rollback
                  </button>
                </div>
              </div>
            </div>
            <div
              *ngIf="versions.length === 0"
              class="p-4 text-center text-muted"
            >
              No history found
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
